import './_product-card-badge.scss';

export default () => {};
